export const AUTH_SUCCESS = 'AUTH_SUCCESS'
export const AUTH_LOGOUT = 'AUTH_LOGOUT'
export const AUTH_ERROR = 'AUTH_ERROR'
export const REFRESH_SUCCESS = 'REFRESH_SUCCESS'
export const SET_LOGOUT = 'SET_LOGOUT'
export const SET_SUBSCRIBED = 'SET_SUBSCRIBED'
